import { getRem, wordBreak } from 'lib/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ToastContent = ({ withMultipleActions, ...other }) => (
  <StyledToastContent $withMultipleActions={withMultipleActions} {...other} />
);

const StyledToastContent = styled.div`
  ${wordBreak}
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  padding: ${({ theme }) => `${theme.size.spacing.large.value} ${getRem('14px')}`};
  padding-bottom: ${({ $withMultipleActions = false, theme }) =>
    $withMultipleActions ? 0 : theme.size.spacing.large.value};
  touch-action: none;
`;

ToastContent.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,
  /** If true sets padding-bottom to 0 */
  withMultipleActions: PropTypes.bool,
};

export { ToastContent };
